import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: require("./src/locales/en.json"),
  },
  ar: {
    translation: require("./src/locales/ar.json"),
  },
};
const DEFAULT_LANGUAGE = "en";

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lng") || DEFAULT_LANGUAGE, // Retrieve from local storage
  interpolation: {
    escapeValue: false,
  },
});
